export default __webpack_public_path__ + "static/char-s-10-cht-c19526980ab0c258c15d3d728961e8fa.png";